import { createApp } from 'vue';

import { Calendar, DatePicker } from 'v-calendar';

import clickOutside from '@/plugins/clickOutside';
import cursorEnd from '@/plugins/cursorEnd';
import { i18n } from '@/plugins/i18n';
import pinia from '@/plugins/pinia';
import { setupSentry } from '@/plugins/sentry';
import { registerServiceWorkerAudio } from '@/utils/registerServiceWorker';

import App from './App.vue';
import router from './router';

import '@/assets/css/reset.css';
import '@/assets/css/variables.css';
import '@/assets/css/main.css';
import '@/assets/css/toast.css';
import './assets/sass/main.scss';
import 'v-calendar/style.css';

const app = createApp(App);

app.use(router);
app.use(i18n);
app.use(pinia());

setupSentry(app, router);
app.mount('#app');

app.component('VCalendar', Calendar);
app.component('VDatePicker', DatePicker);

app.directive('ClickOutside', clickOutside);
app.directive('CursorEnd', cursorEnd);

registerServiceWorkerAudio();
